import { Routes, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Floater } from 'components'

// 핀카
import Fincar from './home'
import FincarIntro from './FincarIntro'

// 차량검색
import FincarPopular from './FincarPopular'
import FincarRecommend from './FincarRecommend'
import FincarSearchEnter from './FincarSearchEnter'
import FincarSearchFilter from './FincarSearchFilter'
import FincarResult from './FincarResult'
import FincarAttention from './FincarAttention'
import FincarDetail from './FincarDetail'



// fincar
const Index = () => {

	return (
		<>
			{/* <Floater>
				<li><Link to="">핀카 메인</Link></li>
			</Floater> */}
			<Routes>
				<Route path="/fincarAttention" element={<FincarAttention />} /> { /* 내 관심차량 */}



				<Route path="/fincarDetail" element={<FincarDetail />} /> { /* 차량 상세 */}
				<Route path="/fincarResult" element={<FincarResult />} /> { /* 차량조회 결과 */}
				<Route path="/fincarSearchFilter" element={<FincarSearchFilter />} /> { /* 차량조회_필터검색 */}
				<Route path="/fincarSearchEnter" element={<FincarSearchEnter />} /> { /* 차량조회_직접입력 */}
				<Route path="/fincarRecommend" element={<FincarRecommend />} /> { /* 차량추천_카테고리별 */}
				<Route path="/fincarPopular" element={<FincarPopular />} /> { /* 차량추천_성별/연령대별 */}

				<Route path="/fincarIntro" element={<FincarIntro />} /> { /* 핀카 인트로 */}
				<Route path="/" element={<Fincar />} /> { /* 핀카 메인 */}
			</Routes>
		</>
	)
}

export default Index